// extracted by mini-css-extract-plugin
export default {"layoutToggleFormControl":"layout-toggle-module__layoutToggleFormControl--Emyt8","layoutToggleLabel":"layout-toggle-module__layoutToggleLabel--Oe4MR"};